import { LogScaleButton } from './LogScaleButton';

export { LogScaleButton };

export default LogScaleButton;
